import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    addRegionalProjectRequest: ['response'],
    addRegionalProjectSuccess: ['loading', 'response'],
    addRegionalProjectFailure: ['error'],
})

export const addRegionalProjectTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const addRegionalProjectRequest = state => state.merge({ success: null })

const addRegionalProjectSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const addRegionalProjectFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.ADD_REGIONAL_PROJECT_REQUEST]: addRegionalProjectRequest,
    [Types.ADD_REGIONAL_PROJECT_SUCCESS]: addRegionalProjectSuccess,
    [Types.ADD_REGIONAL_PROJECT_FAILURE]: addRegionalProjectFailure,
})
